import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractFilter} from '../abstract-filter';
import {PluginFilter, PluginSettings} from '../abstract-data-api-plugin';

interface EventFilter extends PluginFilter {
}

interface EventSettings extends PluginSettings {
}

export {EventFilter, EventSettings};

/**
 * Event filter.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Filter extends AbstractFilter<EventFilter, EventSettings> {
  constructor(container: HTMLElement) {
    super(container, 'event', {
      category: 0
    } as EventFilter);
    DataApi.instance.eventEndpoint.distinctValues(this.settings)
      .then(response => {
        const template = require('../../handlebars/templates/event/filter.handlebars');
        const html = template({
          distinctValues: response,
          filter: this.filter
        });
        this.update(html);
        this.initializeResult();

        ComponentRegistry.add('event-filter', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
